export const L10N = {
  LABEL_CARD_NAME: { id: 'core.label.card_name' },
  LABEL_CARD_NUMBER: { id: 'core.label.card_number' },
  LABEL_CVV: { id: 'core.label.cvv' },
  LABEL_EXPIRATION: { id: 'core.label.expiration' },
  LABEL_MONTH_FORMAT: { id: 'core.label.month_format' },
  LABEL_YEAR_FORMAT: { id: 'core.label.year_format' },
};
